import { ConfigValidationError } from "../../../../../../types";
import { ComponentConfigState } from "../../../../types";

export default function errorSelector(
  _state: ComponentConfigState
): ConfigValidationError[] {
  return [];
}
